const collator = new Intl.Collator(undefined, {
  sensitivity: 'base',
  numeric: true,
});

/**
 * Compares two labels the way a person reads a list: case-insensitive, and
 * with runs of digits compared as numbers, so "Team 2" sorts before "Team 10".
 */
export const compareAlphanumeric = (
  a: string | null | undefined,
  b: string | null | undefined
): number => collator.compare(a ?? '', b ?? '');

/** A sorted copy of `items`, ordered by `getLabel` with `compareAlphanumeric`. */
export const sortAlphanumeric = <T>(
  items: readonly T[] | null | undefined,
  getLabel: (item: T) => string | null | undefined
): T[] =>
  [...(items ?? [])].sort((a, b) =>
    compareAlphanumeric(getLabel(a), getLabel(b))
  );
